import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InspectorComponent } from './_dashboard/inspector/inspector.component';
import { BrandingComponent } from './_dashboard/branding/branding.component';
import { ContentComponent } from './_dashboard/content/content.component';
import { QuestionsComponent } from './_dashboard/questions/questions.component';
import { CostsComponent } from './_dashboard/costs/costs.component';
import { PackagingComponent } from './_dashboard/packaging/packaging.component';
import { PopulationsComponent } from './_dashboard/populations/populations.component';
import { PopulationDetailComponent } from './_dashboard/populations/population-detail.component';
import { TablesComponent } from './_dashboard/tables/tables.component';
import { TableDetailComponent } from './_dashboard/tables/table-detail.component';
import { FormulasComponent } from './_dashboard/formulas/formulas.component';
import { FormulaDetailComponent } from './_dashboard/formulas/formula-detail.component';
import { SuperadminComponent } from './_dashboard/superadmin/superadmin.component';
import { AuthGuard } from './_services/auth.guard';
import { NoAccessComponent } from './no-access/no-access.component';
import { QuestionsAdminComponent } from './_dashboard/questions-admin/questions-admin.component';
import { DashboardComponent } from './_dashboard/dashboard/dashboard.component';
import { SessionsComponent } from './_dashboard/sessions/sessions.component';
import { ApiErrorsComponent } from './_dashboard/api-errors/api-errors.component';
import { SchoolsComponent } from './schools/schools.component';
import { CreateSchoolComponent } from './schools/create-school.component';
import { DefaultContentComponent } from './schools/default-content.component';
import { externalLoginGuard } from '_services/external-login.guard';
import { EplLoginComponent } from './epl-login/epl-login.component';
import { SupportComponent } from './support/support.component';
import { supportLoginGuard } from '_services/support-login.guard';
import { AuthenticatedLayoutComponent } from './layouts/authenticated-layout.component';
import { RedirectGuard } from './_services/redirect.guard';
import { LoadingGuard } from './_services/loading.guard';
import { OnboardingComponent } from './_dashboard/onboarding/onboarding.component';
import { AnalyticsComponent } from './_dashboard/analytics/analytics.component';
import { TrafficComponent } from './_dashboard/traffic/traffic.component';


const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        canActivate: [RedirectGuard],
        children: [{ path: '', component: NoAccessComponent }]// This is a placeholder and won't be shown
    },
    { path: 'no-access', component: NoAccessComponent },
    { path: 'epl-login', component: EplLoginComponent, canActivate: [externalLoginGuard] },
    { path: 'support', component: SupportComponent, canActivate: [supportLoginGuard] },
    { path: 'admin-login', redirectTo: 'epl-login', pathMatch: 'full' },
    { path: 'schools', component: SchoolsComponent, canActivate: [AuthGuard] },
    { path: 'schools/new', component: CreateSchoolComponent, canActivate: [AuthGuard] },
    { path: 'defaults/content', component: DefaultContentComponent, canActivate: [AuthGuard] },
    {
        path: ':schoolId',
        component: AuthenticatedLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: DashboardComponent, canActivate: [LoadingGuard] },
            { path: 'traffic', component: TrafficComponent, canActivate: [LoadingGuard] },
            { path: 'inspector', component: InspectorComponent, canActivate: [LoadingGuard] },
            { path: 'branding', component: BrandingComponent, canActivate: [LoadingGuard] },
            { path: 'onboarding', component: OnboardingComponent, canActivate: [LoadingGuard] },
            { path: 'content', component: ContentComponent, canActivate: [LoadingGuard] },
            { path: 'questions', component: QuestionsComponent, canActivate: [LoadingGuard] },
            { path: 'costs', component: CostsComponent, canActivate: [LoadingGuard] },
            { path: 'packaging', component: PackagingComponent, canActivate: [LoadingGuard] },
            {
                path: 'populations',
                canActivate: [LoadingGuard],
                children: [
                    { path: '', component: PopulationsComponent },
                    { path: 'new', component: PopulationDetailComponent },
                    { path: ':populationId', component: PopulationDetailComponent }
                ]
            },
            {
                path: 'tables',
                canActivate: [LoadingGuard],
                children: [
                    { path: '', component: TablesComponent },
                    { path: 'new', component: TableDetailComponent },
                    { path: ':tableId', component: TableDetailComponent }
                ]
            },
            {
                path: 'formulas',
                canActivate: [LoadingGuard],
                children: [
                    { path: '', component: FormulasComponent },
                    { path: 'new', component: FormulaDetailComponent },
                    { path: ':formulaId', component: FormulaDetailComponent }
                ]
            },
            { path: 'superadmin', component: SuperadminComponent, canActivate: [LoadingGuard] },
            { path: 'questions-admin', component: QuestionsAdminComponent, canActivate: [LoadingGuard] },
            { path: 'api-errors', component: ApiErrorsComponent, canActivate: [LoadingGuard] },
            { path: 'sessions', component: SessionsComponent, canActivate: [LoadingGuard] },
            { path: 'analytics', component: AnalyticsComponent, canActivate: [LoadingGuard] },
        ]
    },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
